import lookbook from './lookbook.vue'

export default lookbook
